import React from 'react'
import { Button } from '@/components/ui/button'
import { CheckCircle2, X } from 'lucide-react'
import SeveranceNotice from './SeveranceNotice'
import type { DecoupleResult } from './DecoupleMemberDialog'

interface GroupChangeReportProps {
  result: DecoupleResult
  onDismiss: () => void
}

// WHAT ACTUALLY HAPPENED, after a decouple or a dissolve.
//
// Not a toast. Locked product rule 4 requires the resulting gap to be surfaced AFTER the split, and
// a list of rooms that now need a base rate — each with a link to the page that sets one — is a
// worklist, not a notification. A toast that fades in four seconds is the wrong container for it, in
// exactly the way a healed PMS connection is not a transient chip: it stays on the page that changed
// until the operator dismisses it.
//
// The headline is composed by the BACKEND from the mutation's real result, so what is reported here
// is what the mutation did, never the frontend's guess at what it probably did.
export default function GroupChangeReport({ result, onDismiss }: GroupChangeReportProps) {
  return (
    <section className="animate-slide-in" style={{ animationDelay: '0ms' }}>
      <div className="overflow-hidden rounded-xl border border-emerald-200 bg-white shadow-sm">
        <div className="flex items-start gap-3 border-b border-emerald-100 bg-emerald-50/60 px-5 py-4">
          <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-emerald-600" />
          <p role="status" className="flex-1 text-sm font-medium text-emerald-900">
            {result.headline}
          </p>
          <Button
            variant="ghost"
            size="sm"
            className="-mr-1.5 -mt-1 h-8 w-8 shrink-0 p-0 text-emerald-700 hover:text-emerald-900"
            onClick={onDismiss}
            aria-label="Dismiss"
          >
            <X className="h-4 w-4" />
          </Button>
        </div>

        {result.severed.length > 0 && (
          <div className="p-5">
            <SeveranceNotice severed={result.severed} mode="after" subject={result.subject} />
          </div>
        )}
      </div>
    </section>
  )
}
